import { render } from "./NewsConstructor.vue?vue&type=template&id=1bacb490&scoped=true"
import script from "./NewsConstructor.vue?vue&type=script&lang=js"
export * from "./NewsConstructor.vue?vue&type=script&lang=js"

import "./NewsConstructor.vue?vue&type=style&index=0&id=1bacb490&lang=css"
import "./NewsConstructor.vue?vue&type=style&index=1&id=1bacb490&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bacb490"]])

export default __exports__